<template>
  <div class="view-control with-background">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="jumbotron">
            <h1>Control de subasta {{ auction }}</h1>
            <p class="text-center" :class="connectedUsersClass">
              Usuarios conectados: {{ connectedUsers }}
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <ControlList />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ControlList from "../components/ControlList";

export default {
  name: "Control",
  components: {
    ControlList,
  },
  props: {
    auction: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    loggedInMembership: function () {
      return this.$store.getters.loggedInMembership;
    },
    connectedUsers: function () {
      return this.$store.getters.connectedUsers;
    },
    connectedUsersClass: function () {
      return this.connectedUsers > 0 ? "" : "hidden";
    },
  },
  created: async function () {
    if (!this.isLoggedIn || this.loggedInMembership > 200) {
      this.$router.replace("/");
      return;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/partial";

.view-control {
  > div {
    background-color: $white;
  }
}
.jumbotron,
h1 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
p.hidden {
  color: $red;
}
</style>